const truncate = (input, length = 10) =>
    input.length > length ? `${input.substring(0, length)}...` : input;

export { truncate };
